export class NetworkError extends Error {}
export class ApiError extends Error {
  constructor(message: string, public statusCode: string) {
    super(message);
  }
}